import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LightboxesService {
  public timeoutID: any

  constructor() { }

  open(message: { title: string, text: string }, time: number = 1000) {
    document.querySelector('#custom-message').classList.remove('hidden')
    document.querySelector('.Message_Title').innerHTML = message.title
    document.querySelector('.Message_Content').innerHTML = message.text

    this.timeoutID = setTimeout(() => {
      this.close()
    }, time);
  }

  close() {
    document.querySelector('#custom-message').classList.add('hidden')
    if(this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = null;
    }
  }
}
